<section class="light-blue">
    <div class="row">
        <div class="col-lg-12">
            <img src="../../../assets/img/under-maintence.svg" class="image-logo img-fluid" alt="">
            <h4>{{LabelConstant.title}}</h4>
            <p>{{LabelConstant.mainParagraph}}<br />
                {{LabelConstant.paragraph}}</p>
        </div>
    </div>
</section>